import { useId, type SVGAttributes } from "react";

/**
 * Hümo logo as inline SVG. Source of truth: marketing/instagram/brand.js
 * (exported files in marketing/brand/). Keep the paths in sync with it.
 */

const SKY = "#4F8CFF";
const VIOLET = "#7B61FF";
const H_PATH = "M176 146V366M336 146V366M176 330C176 260 246 232 336 232";

interface HumoMarkProps extends SVGAttributes<SVGSVGElement> {
  /** "tile": white H on the gradient rounded square. "bare": H only, in currentColor. */
  variant?: "tile" | "bare";
}

export const HumoMark = ({ variant = "tile", ...props }: HumoMarkProps) => {
  const id = useId();
  return (
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false" {...props}>
      {variant === "tile" && (
        <>
          <defs>
            <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="512" y2="512">
              <stop offset="0" stopColor={SKY} />
              <stop offset="1" stopColor={VIOLET} />
            </linearGradient>
          </defs>
          <rect width="512" height="512" rx="116" fill={`url(#${id})`} />
        </>
      )}
      <path
        d={H_PATH}
        fill="none"
        stroke={variant === "tile" ? "#fff" : "currentColor"}
        strokeWidth="64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/** "hümo" wordmark. Letters follow currentColor; the umlaut dots keep the brand colors. */
export const HumoWordmark = (props: SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="-4 8 364 126" role="img" aria-label="Hümo" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="14" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 20V120M7 82A26 26 0 0 1 59 82V120M85 56V94A26 26 0 0 0 137 94M137 56V120M163 56V120M163 80A24 24 0 0 1 211 80V120M211 80A24 24 0 0 1 259 80V120" />
      <circle cx="317" cy="88" r="32" />
    </g>
    <circle cx="89" cy="30" r="10" fill={SKY} />
    <circle cx="133" cy="30" r="10" fill={VIOLET} />
  </svg>
);
